(function($){
  $(document).ready(function(){
    videlxu.init();
  });
})(jQuery);
var pathname = window.location.href;
var allLetter = function(inputtxt,element){    
  if (inputtxt.match(/(?=.*[@!\$\^%&*+=\-\[\]\\\';\/\{\}\|\":<>\?]+?).*[^_\W]+?.*/)){
    ShopifyApp.flashError("String contains both alpha-numeric and your pre-defined special characters!");
    return 1;
  }
  return 0;
}
var delay = (function(){
  var timer = 0;
  return function(callback, ms){
    clearTimeout (timer);
    timer = setTimeout(callback, ms);
  };
})();
var videlxu = {
  loadPage: function(){
    setTimeout(function() {
      $('.slideshow__text-content').addClass('active_slideshow');
    }, 200);
  },
  init: function(){
    this.loadPage();
  }
}